<template>
    <div>
        <div class="page-title">
            <PageTitle class="page-home-title" fontSize="35" icon="fa fa-cogs" title="Central de Aplicações"/> 
        </div>
        <!-- botões das aplicações-->
        <Applications />
    </div>
</template>

<script>
//compoenents
import PageTitle from "@/components/template/PageTitle";
import Applications from "@/components/application/Applications"
import { baseApiUrl } from "@/global";
export default {
    name: 'Index',
    components: { PageTitle, Applications },
    mounted() {
        console.log(baseApiUrl);
    }
}
</script>

<style>
.page-title {
    margin-top: 2px;
    text-align: center;
}

</style>